<template>
  <b-card>
    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col md="6">
          <b-form-group label-for="kategoriJenisTiketList" label="Kategori Konsultasi">
            <v-select
              :disabled="disabled == 1"
              v-model="optionsLocal.kategori_jenis_tiket_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="kategoriJenisTiketOptions.options"
              :reduce="val => val.value"
              :clearable="false"
              input-id="kategori_jenis_tiket"
              @input="val => changeJenisTiket(val)"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label-for="jenisTiketList" label="Jenis Konsultasi">
            <v-select
              :disabled="disabled == 1"
              v-model="optionsLocal.jenis_tiket_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="jenisTiketOptions.options"
              :reduce="val => val.value"
              :clearable="false"
              input-id="jenis_tiket"
              @input="val => changeFileShow(val, jenisTiketOptions)"
            />
          </b-form-group>
        </b-col>
        <!--
        <b-col md="6">
          <b-form-group
            label="Tanggal Mulai"
          >
            <flat-pickr
              v-model="optionsLocal.tanggal_mulai"
              class="form-control"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Tanggal Akhir"
          >
            <flat-pickr
              v-model="optionsLocal.tanggal_akhir"
              class="form-control"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Status"
            label-for="account-name"
          >
            <v-select
              id="statusList"
              v-model="optionsLocal.private"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOption"
              item-text="id"
              item-value="label"
              @input="(val) => changePrivate(val)"
            />
          </b-form-group>
        </b-col>
        <b-col md="6"
          v-if="showPassword"
        >
          <b-form-group
            label-for="account-new-password"
            label="Masukan Password"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="account-new-password"
                v-model="optionsLocal.password"
                :type="passwordFieldTypeNew"
                name="new-password"
                placeholder="Masukan Password Baru"
              />
              <b-input-group-append is-text>
                <feather-icon
                  :icon="passwordToggleIconNew"
                  class="cursor-pointer"
                  @click="togglePasswordNew"
                />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col> -->
        <!-- deskripsi -->
        <!-- <div v-if="showFile">
          <b-col cols="12" >
            <b-form-group
              label="Upload File"
              label-for="upload-file">
              <input type="file" @change="changeFile" accept="image/*,application/pdf"/>
              <object v-if="seen"  :data="blob" width="100%" height="700"/>
            </b-form-group>
          </b-col>
        </div> -->
        <div v-if="showFile">
          <b-col cols="12">
            <b-form-group label="Upload File (2 MB)" label-for="upload-file">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                class="mb-75 mr-75"
                @click="$refs.refInputEl.$el.click()"
              >
                Upload
              </b-button>
              <b-form-file
                id="flg_document"
                ref="refInputEl"
                v-model="optionsLocal.File"
                accept="application/pdf"
                :hidden="true"
                plain
                @input="changeFile"
              />

              <b>{{ optionsLocal.name_file }}</b>
              <!-- <object
                v-if="seen"
                :data="blob"
                width="100%"
                height="700"></object> -->
            </b-form-group>
          </b-col>
        </div>
        <div v-if="divDownload">
          <b-col cols="12">
            <b-form-group label="Download File" label-for="upload-file">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                class="mb-75 mr-75"
                @click="download"
              >
                Download
              </b-button>
            </b-form-group>
          </b-col>
        </div>
        <div v-if="divDownload">
          <b-col cols="12" style="margin-top:13.3%; margin-left:-15%">
            <b-form-group label="" label-for="upload-file" :style="{ color: white }">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                size="sm"
                class="mb-75 mr-75"
                v-if="
                  optionsLocal.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616f0' ||
                    optionsLocal.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe22'
                "
                @click="changeReUploadFile"
              >
                Upload Ulang
              </b-button>
            </b-form-group>
          </b-col>
        </div>
        <!-- <b-media no-body>
          <b-media-body class="mt-75 ml-75">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              size="sm"
              class="mb-75 mr-75"
              @click="$refs.refInputEl.$el.click()"
            >
              Upload
            </b-button>
            <b-form-file
              ref="refInputEl"
              v-model="optionsLocal.File"
              accept="application/pdf"
              :hidden="true"
              plain
              @input="changeFile"
            />
            <b-card-text>PDF of 800kB</b-card-text>
          </b-media-body>
        </b-media> -->
        <b-col cols="12">
          <b-form-group label="Judul" label-for="keterangan-area">
            <b-form-input
              :disabled="disabled == 1"
              id="keterangan-area"
              v-model="optionsLocal.keterangan"
              rows="4"
              placeholder="Keterangan disini..."
            />
          </b-form-group>
        </b-col>
        <!-- output -->
        <b-col cols="12">
          <b-form-group label="Detail Permasalahan" label-for="permasalahan-area">
            <b-form-textarea
              :disabled="disabled == 1"
              id="permasalahan-area"
              v-model="optionsLocal.permasalahan"
              rows="4"
              placeholder="Permasalahan selengkapnya disini..."
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="divTeamViewer">
          <b-form-group label="ID TeamViewer" label-for="id-teamviewer">
            <!-- <b-form-input
              :disabled="disabled == 1"
              v-model="optionsLocal.id_teamviewer"
              name="id-teamviewer"
              placeholder="ID TeamViewer"
              type="number"
            /> -->
            <cleave
              id="id-teamviewer"
              v-model="optionsLocal.id_teamviewer"
              name="id-teamviewer"
              :raw="false"
              class="form-control"
              :options="cleveNumber"
              autocomplete="off"
              placeholder="ID TeamViewer"
              :disabled="disabled == 1"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="divTeamViewer">
          <b-form-group label="Password TeamViewer" label-for="pass-teamviewer">
            <b-form-input
              :disabled="disabled == 1"
              v-model="optionsLocal.password_teamviewer"
              name="pass-teamviewer"
              placeholder="Password TeamViewer"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="simpan"
            :disabled="isDisabled"
            v-if="optionsLocal.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616f0'"
          >
            Simpan
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="ubah"
            v-if="optionsLocal.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe22'"
          >
            Edit
          </b-button>
          <b-button variant="primary" disabled v-if="optionsLocal.loading === true">
            <b-spinner small type="grow"></b-spinner>
            Loading Get Data...
          </b-button>
          <!-- <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mt-2 mr-1"
            @click="kirim"
            v-if="optionsLocal.status_tiket_id === 0 && $route.params.id"
          >
            Kirim
          </b-button> -->
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            type="reset"
            class="mt-2"
            @click.prevent="resetForm"
          >
            Reset
          </b-button> //-->
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
// import {
//   BButton, BForm, BFormGroup, BFormTextarea, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BMedia, BMediaAside,
//   BFormSelect, BInputGroup, BInputGroupAppend,
// } from 'bootstrap-vue'
import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormTextarea,
  BRow,
  BCol,
  BAlert,
  BCard,
  BLink,
  BSpinner,
  BFormInput,
} from 'bootstrap-vue'
import {
  getTiket,
  downloadDokumenTiket,
  getKategoriJenisTiketByRoles,
  getKategoriJenisTiketByKemampuan,
} from '@/connection-api/tiket'
import {
  getKategoriJenisTiket,
  getJenisTiket,
  getJenisTiketById,
  getPertanyaan,
  getJenisTiketRoles,
  getJenisTiketKemampuan,
} from '@/connection-api/master'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
// import { ref } from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'
import axios from 'axios'
import Cleave from 'vue-cleave-component'

export default {
  // components: {
  //   BButton,
  //   BForm,
  //   BFormGroup,
  //   // BFormInput,
  //   BRow,
  //   BCol,
  //   BCard,
  //   BFormTextarea,
  //   // flatPickr,
  //   // BInputGroup,
  //   // BInputGroupAppend,
  //   vSelect,
  // },
  components: {
    BButton,
    BForm,
    BFormFile,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BFormTextarea,
    vSelect,
    BSpinner,
    BFormInput,
    Cleave,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      optionsLocal: {
        status_tiket_id: 'e2281ff8-2558-11ee-acb1-3497f616f0',
      },
      date: null,
      localData: [],
      disabled: 0,
      /* eslint-disable global-require */
      avatar: require('@/assets/images/pages/default.png'),
      userData: JSON.parse(localStorage.getItem('userData')),
      /* eslint-disable global-require */
      passwordFieldTypeNew: 'password',
      showPassword: false,
      statusOption: [
        {
          id: 0,
          label: 'Publik',
        },
        {
          id: 1,
          label: 'Privat',
        },
      ],
      kategoriJenisTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Kategori Jenis Konsultasi --' }],
      },
      jenisTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis Konsultasi --' }],
      },
      blob: null,
      seen: false,
      showFile: false,
      divDownload: false,
      divTeamViewer: false,
      cleveNumber: {
        blocks: [18],
        numericOnly: true,
      },
    }
  },
  computed: {
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  async mounted() {
    // console.log(this.userData)
    this.optionsLocal.loading = false
    if (this.$route.params.id) {
      this.optionsLocal.loading = true
      this.getTiket(this.$route.params.id)
    } else {
      this.getKategoriTiket()
    }
    // console.log(this.optionsLocal.select_proyek)
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async getTiket(value) {
      let params = {}
      if (this.$can('proses', 'tiket')) {
        params = { proses: true }
      }
      const response = await getTiket(value, params)
      this.localData = response.data.data
      this.optionsLocal = this.localData
      this.changeJenisTiket(this.optionsLocal.kategori_jenis_tiket_id)
      if (response.data.data.user_tiket_id === null) {
        this.optionsLocal.loading = false
        const resp = await getTiket(value, params)
        this.optionsLocal.status_tiket_id = resp.data.data.status_tiket_id
      }
      this.optionsLocal.loading = false

      if (
        // eslint-disable-next-line operator-linebreak
        this.optionsLocal.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616f0' ||
        this.optionsLocal.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe22'
      ) {
        this.disabled = 0
      } else {
        this.disabled = 1
      }

      this.getKategoriTiket()

      // console.log(389)

      // console.log(this.optionsLocal)
    },
    async getKategoriTiket() {
      try {
        const validasiUser = this.validasiUser(this.userData)
        if (validasiUser === 1) {
          const responseKategoriJenisTiket = await getKategoriJenisTiket()
          this.mappingSelectOption(
            responseKategoriJenisTiket.data,
            this.kategoriJenisTiketOptions.options,
          )
        } else if (validasiUser === 3) {
          const responseKategoriJenisTiket = await getKategoriJenisTiketByKemampuan()
          this.mappingSelectOption(
            responseKategoriJenisTiket.data,
            this.kategoriJenisTiketOptions.options,
          )
        } else {
          const responseKategoriJenisTiket = await getKategoriJenisTiketByRoles()
          this.mappingSelectOption(
            responseKategoriJenisTiket.data,
            this.kategoriJenisTiketOptions.options,
          )
        }
      } catch (error) {
        // console.log(error.response.data)
      }
    },
    validasiUser(dataUser) {
      // console.log('aaaa')
      // console.log(this.optionsLocal.is_draft)
      let returnalue = 0
      if (
        // eslint-disable-next-line operator-linebreak
        (dataUser.roles.indexOf('superadmin') !== -1 ||
          // eslint-disable-next-line operator-linebreak
          dataUser.roles.indexOf('admin') !== -1 ||
          // eslint-disable-next-line operator-linebreak
          dataUser.roles.indexOf('ditjenpas') !== -1 ||
          // eslint-disable-next-line operator-linebreak
          dataUser.roles.indexOf('helpdesk') !== -1 ||
          // eslint-disable-next-line operator-linebreak
          dataUser.roles.indexOf('supervisor') !== -1) &&
        // eslint-disable-next-line operator-linebreak
        this.$route.params.id &&
        this.optionsLocal.status_tiket_id !== 'e2281ff8-2558-11ee-acb1-3497f616f0'
      ) {
        returnalue = 1
      } else if (
        // eslint-disable-next-line operator-linebreak
        dataUser.roles.indexOf('supervisor') !== -1 &&
        this.optionsLocal.is_draft === undefined
      ) {
        returnalue = 3
      } else {
        returnalue = 2
      }
      return returnalue
    },
    async changeJenisTiket(value) {
      if (value === '22e54eef-254b-11ee-acb1-3497f616fa2') {
        this.divTeamViewer = true
      } else {
        this.divTeamViewer = false
      }
      this.reloadJenisTiketOptions(value)
      this.showFile = false
      this.divDownload = false
      if (this.$route.params.id) {
        if (this.optionsLocal.jenis_tiket_id_tr === undefined) {
          this.optionsLocal.jenis_tiket_id_tr = this.optionsLocal.jenis_tiket_id
          this.optionsLocal.kategori_jenis_tiket_id_tr = this.optionsLocal.kategori_jenis_tiket_id
        }
        try {
          const resp = await getJenisTiketById(this.optionsLocal.jenis_tiket_id)
          if (
            // eslint-disable-next-line operator-linebreak
            resp.data.data.flg_document === 1 &&
            resp.data.data.kategori_jenis_tiket_id === this.optionsLocal.kategori_jenis_tiket_id
          ) {
            this.divDownload = true
          } else {
            this.divDownload = false
          }
          this.optionsLocal.flg_document = resp.data.data.flg_document
        } catch (error) {
          // console.log('id tidak ada')
        }
      }
    },
    async reloadJenisTiketOptions(kategoriJenisTiketId) {
      this.jenisTiketOptions = {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis --' }],
      }
      const validasiUser = this.validasiUser(this.userData)
      if (validasiUser === 1) {
        // alert('aa')
        const response = await getJenisTiket({
          kategori_jenis_tiket_id: kategoriJenisTiketId,
          perPage: 100,
          page: 1,
        })
        this.mappingSelectOption(response.data.data, this.jenisTiketOptions.options)
      } else if (validasiUser === 3) {
        // alert('aa')
        const response = await getJenisTiketKemampuan({
          kategori_jenis_tiket_id: kategoriJenisTiketId,
          perPage: 100,
          page: 1,
        })
        this.mappingSelectOption(response.data.data, this.jenisTiketOptions.options)
      } else {
        const response = await getJenisTiketRoles({
          kategori_jenis_tiket_id: kategoriJenisTiketId,
          perPage: 100,
          page: 1,
        })
        this.mappingSelectOption(response.data.data, this.jenisTiketOptions.options)
      }
    },
    resetForm() {
      this.optionsLocal = []
    },
    simpan() {
      this.optionsLocal.flg_kirim = 1
      this.$emit('click')
      if (this.$route.params.id) {
        this.optionsLocal.tiket_id = this.$route.params.id
        this.optionsLocal.flg_kirim = 1
      }
      // this.optionsLocal.flg_upload_ulang = 0
      this.localData = this.optionsLocal
      this.$emit('clicked', this.localData)
    },
    ubah() {
      this.optionsLocal.flg_kirim = 0
      if (this.$route.params.id) {
        this.optionsLocal.tiket_id = this.$route.params.id
        this.optionsLocal.flg_kirim = 0
      }
      // this.optionsLocal.flg_upload_ulang = 0
      this.localData = this.optionsLocal
      this.$emit('clicked', this.localData)
    },
    kirim() {
      if (this.$route.params.id) {
        this.optionsLocal.tiket_id = this.$route.params.id
      }
      this.optionsLocal.flg_kirim = 1
      this.localData = this.optionsLocal
      this.$emit('clicked', this.localData)
    },
    onFileChange(e) {
      const file = e.target.files[0]
      this.optionsLocal.img = URL.createObjectURL(file)
      this.optionsLocal.image = this.optionsLocal.img
    },
    changeFile(event) {
      this.seen = true
      const file = event
      // console.log('472')
      // console.log(file.name)
      this.optionsLocal.img = URL.createObjectURL(file)
      this.optionsLocal.image = this.optionsLocal.img
      this.blob = URL.createObjectURL(file)
      this.optionsLocal.flg_upload_ulang = 1
      this.optionsLocal.name_file = file.name
    },
    changeReUploadFile(event) {
      this.divDownload = false
      this.showFile = true
      this.optionsLocal.flg_upload_ulang = 1
    },
    async changeFileShow(value, changeFileShow) {
      this.seen = false
      try {
        const resp = await getJenisTiketById(value)
        this.optionsLocal.flg_document = resp.data.data.flg_document
        this.optionsLocal.flg_upload_ulang = 1
        if (this.optionsLocal.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616f0') {
          if (resp.data.data.flg_document === 1) {
            if (resp.data.data.id === this.optionsLocal.jenis_tiket_id_tr) {
              this.showFile = false
              this.divDownload = true
            } else {
              this.showFile = true
              this.divDownload = false
            }
          } else {
            this.showFile = false
            this.divDownload = false
          }
        } else if (this.optionsLocal.status_tiket_id !== 'e2281ff8-2558-11ee-acb1-3497f616f0') {
          if (this.optionsLocal.id === undefined) {
            // alert('bdk')
            if (resp.data.data.flg_document === 1) {
              this.showFile = true
            } else {
              this.showFile = false
            }
          } else if (this.optionsLocal.id !== undefined) {
            if (
              // eslint-disable-next-line operator-linebreak
              resp.data.data.flg_document === 1 &&
              resp.data.data.id === this.optionsLocal.jenis_tiket_id_tr
            ) {
              this.divDownload = true
            } else {
              this.divDownload = false
            }
          }
        }
      } catch (error) {
        // console.log('id tidak ada')
      }
    },
    async download() {
      // this.show = true
      try {
        const resp = await downloadDokumenTiket(this.optionsLocal.file)
        // const fileURL = window.URL.createObjectURL(new Blob([resp.data]))
        const fileURL = window.URL.createObjectURL(
          new Blob([resp.data], { type: 'application/pdf' }),
        )
        const fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute('download', this.optionsLocal.file)
        document.body.appendChild(fileLink)
        fileLink.click()
        // this.show = false
      } catch (error) {
        // this.show = false
        this.makeToast('danger', 'gagal')
      }
    },
    downloadold() {
      axios({
        url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        method: 'GET',
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'dummy.pdf')
        document.body.appendChild(link)
        link.click()
      })
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Tiket',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl)
    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
